import React from 'react';
import { NavBarSection } from '@apps/layouts/Navbar/styles';
import { ListItem } from '@mui/material';
import classNames from 'classnames';

import CarLaunchMonthHeaderNavBarItemProps, {
  CarLaunchMonthNavItemRefProps,
} from './props';
import { CarLaunchMonthNavBarItem } from './settings';

export const CarLaunchMonthHeaderNavBarItemView: React.ForwardRefRenderFunction<
  CarLaunchMonthNavItemRefProps,
  CarLaunchMonthHeaderNavBarItemProps
> = (props, ref) => {
  const { handleClick, sectionsData } = props;

  // ======================= HOOKS
  const navItemElementRef = React.useRef<HTMLUListElement | null>(null);
  const [focusedNavItem, setFocusedNavItem] =
    React.useState<CarLaunchMonthNavBarItem>('coming_soon');

  // ======================= EFFECTS
  React.useImperativeHandle(
    ref,
    () => ({
      focusedNavItem,
      setFocusedNavItem,
      element: navItemElementRef.current,
    }),
    [focusedNavItem, setFocusedNavItem, navItemElementRef]
  );

  // ======================= VIEWS
  return (
    <NavBarSection
      ref={navItemElementRef}
      style={{
        display: 'flex',
        flexDirection: 'row',
        overflow: 'scroll',
        whiteSpace: 'nowrap',
        margin: '0 auto',
        scrollbarWidth: 'none',
      }}
    >
      {sectionsData.map((navItem, index) => {
        const { key, title } = navItem;
        const isSelected = focusedNavItem === key;

        return (
          <ListItem
            key={`${index}`}
            id={`carLaunchMonthNavItem_${key}`}
            onClick={(event) => handleClick(event, key)}
            className={classNames('nav-item-launch text-md-unchanged', {
              'nav-ani-overview-selected': isSelected,
              'nav-ani-overview': !isSelected,
            })}
            sx={{
              cursor: 'pointer',
              p: 0,
            }}
          >
            <p
              style={{
                fontSize: 16,
                fontWeight: 700,
                padding: '8px 16px',
              }}
            >
              {title}
            </p>
          </ListItem>
        );
      })}
    </NavBarSection>
  );
};

export const CarLaunchMonthHeaderNavBarItem = React.memo(
  React.forwardRef(CarLaunchMonthHeaderNavBarItemView)
);
